import React from 'react';
import { hasStoreActiveVacation } from "../../utils/dateUtils";

function VacationWarning(props) {
    const vacationStart = props.vacation_start ? new Date(props.vacation_start) : null;
    const vacationEnd = props.vacation_end ? new Date(props.vacation_end) : null;

    if (
        !vacationStart ||
        !vacationEnd ||
        !props.vacation_reason_form ||
        !hasStoreActiveVacation(vacationStart, vacationEnd)
    ) {
        return null;
    }

    return (
        <div className='bg-accent-100 font-bold p-4.5 text-white paragraph-4 text-center'>
            {props.vacation_reason_form}
        </div>
    );
}

export default VacationWarning;
